<template>
  <div class="my-4">
    <h3>
      Zittenblijven, opstroom, en afstroom
      <small style="font-size: 60%">(DUO data)</small>
    </h3>

    <div
      v-if="loaded"
      :class="$style.container"
    >
      <div
        v-for="jaarData in shownDataPerYear"
        :key="jaarData.schooljaarBegin"
      >
        <ZittenblijversTile
          class="mb-4"
          :schooljaar-begin="jaarData.schooljaarBegin"
          :aantal-leerlingen="jaarData.aantalLeerlingen"
          :aantal-zittenblijvers="jaarData.aantalZittenblijvers"
          :aantal-opstromers="jaarData.aantalOpstromers"
          :aantal-afstromers="jaarData.aantalAfstromers"
          :gemiddeld-pct-zittenblijvers-ams="
            findAggregateForSchoolJaar(jaarData.schooljaarBegin).pctZittenblijvers
          "
          :gemiddeld-pct-afstromers-ams="
            findAggregateForSchoolJaar(jaarData.schooljaarBegin).pctAfstromers
          "
          :gemiddeld-pct-opstromers-ams="
            findAggregateForSchoolJaar(jaarData.schooljaarBegin).pctOpstromers
          "
        />
      </div>

      <button
        v-if="!expanded && dataPerJaar.length > 1"
        class="btn btn--black w-100"
        @click="expanded = true"
      >
        Toon meer schooljaren
      </button>

      <div
        v-if="!dataPerJaar.length"
        :class="$style.empty"
      >
        Er is geen data bekend voor deze school
      </div>
    </div>
    <div v-else>
      <BaseLoader />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  listDuoDataZittenblijversByBrin,
  getDuoDataZittenblijversAggregates,
} from '@/repositories/duodataRepository';
import ZittenblijversTile from '@/components/ZittenblijversTile.vue';
import BaseLoader from '@/components/BaseLoader.vue';

export default Vue.extend({
  components: {
    ZittenblijversTile,
    BaseLoader,
  },

  props: {
    school: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loaded: false,
      dataPerJaar: [],
      aggregateData: [],
      expanded: false,
    };
  },

  computed: {
    shownDataPerYear() {
      if (this.dataPerJaar.length > 1) {
        const sortedData = [...this.dataPerJaar];
        sortedData.sort((j1, j2) => j2.schooljaarBegin - j1.schooljaarBegin);
        return this.expanded ? sortedData : sortedData.slice(0, 1);
      }
      return this.dataPerJaar;
    },
  },

  async created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      try {
        const [schoolResponse, aggregateResponse] = await Promise.all([
          listDuoDataZittenblijversByBrin(this.school.brin),
          getDuoDataZittenblijversAggregates(),
        ]);
        this.dataPerJaar = schoolResponse.data;
        this.aggregateData = aggregateResponse.data;
      } finally {
        this.loaded = true;
      }
    },

    findAggregateForSchoolJaar(schooljaar) {
      return this.aggregateData.find((data) => data.schooljaarBegin === schooljaar);
    },
  },
});
</script>

<style module>
.container {
  width: 100%;
}

.empty {
  font-size: 125%;
  color: #888;
  font-style: italic;
}
</style>
